import React from 'react';
import { FunctionColor, Preset as TextPreset } from '@lux/text';
import { ButtonType } from '@lux/buttons';
import { useNavigate } from 'react-router-dom';
import { trackSelectContent } from '@browsing/tracking';
import {
    AllCampaignCardWrapper,
    AllCampaignText,
    AllCampaignImage,
    AllCampaignImageOverlay,
} from './all-campaigns-card.styles';
import { useGRE } from '../../hooks';

interface AllCampaignsCardProps {
    imageUrl: string;
}

const AllCampaignsCard = ({ imageUrl }: AllCampaignsCardProps) => {
    const { greTabData, greData } = useGRE();
    const navigate = useNavigate();

    const handleClick = () => {
        trackSelectContent('gre_carousel', 'click', { contentId: 'see_all_deals_last' });
        navigate(`/event/${greTabData.id}${window.location.search}`);
    };

    return (
        <AllCampaignCardWrapper onClick={handleClick}>
            <AllCampaignImage src={imageUrl} aria-hidden="true" />
            <AllCampaignImageOverlay />
            <AllCampaignText buttonType={ButtonType.tertiary}>
                {greData?.buttonText}
            </AllCampaignText>
        </AllCampaignCardWrapper>
    );
};

export default AllCampaignsCard;
